export const DISCOUNT_TYPE_FIXED = "fixed";

export const ORDER_TYPE_DINE_IN = "dine_in";
export const ORDER_TYPE_TAKE_OUT = "take_out";

export const PAYMENT_METHOD_CASH = "cash";
export const PAYMENT_METHOD_CARD = "card";
export const PAYMENT_METHOD_PROMPTPAY = "promptpay";

export const STATUS_CANCELED = "canceled";
export const STATUS_COMPLETED = "completed";
export const STATUS_FAILED = "failed";
export const STATUS_PENDING = "pending";
export const STATUS_PREPARING = "preparing";
export const STATUS_PROCESSING = "processing";
export const STATUS_READY = "ready";
export const STATUS_SERVED = "served";
